import React, { useRef } from 'react';
import moment from 'moment';
import cls from 'classnames';
import { useHover } from 'ahooks';
import GameImage from '@home/components/GameImage';
import playIcon from '@intelligence/assets/imgs/icon-play.png';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import jumpHover from '@intelligence/assets/svg/gameInfo/jump-hover.svg';

import './index.scss';

interface ISteamNewsItem {
  data: {
    start_time: string;
    cover: string;
    url: string;
    title: string;
    subTitle: string;
    subTitleColor: string;
    desc: string;
  };
  isFirst: boolean;
  isLast: boolean;
}

function SteamNewsItem({ data, isFirst, isLast }: ISteamNewsItem) {
  const { locale, isCN } = useIntlExtend();

  const ref = useRef(null);
  const isHovering = useHover(ref);

  const handleClick = () => {
    data.url && window.open(data.url);
  };

  return (
    <div
      className={cls('dbi-steam-news-item-container', {
        'dbi-steam-news-item-container-last': isLast,
      })}
      ref={ref}
    >
      {!isFirst && <div className="dbi-steam-news-item-line-top" />}
      <div className="dbi-steam-news-item-line-right" />
      <div className="dbi-steam-news-item-line-bottom" />
      <div className="dbi-steam-news-item-circle" />

      <div className="dbi-steam-news-item-time">
        <div
          className={cls('dbi-steam-news-item-date', {
            'dbi-steam-news-item-date-cn': isCN,
            'dbi-steam-news-item-date-en': !isCN,
          })}
        >
          {moment(data.start_time).locale(locale).format('MMM DD')}
          {isCN ? '日' : ''}
        </div>
        <div className="dbi-steam-news-item-year">{moment(data.start_time).format('YYYY')}</div>
      </div>

      <div className="dbi-steam-news-item-img-wrapper" onClick={handleClick}>
        <GameImage className="dbi-steam-news-item-img" entityType="video" src={data.cover} />
        <img className="dbi-steam-news-item-img-play-icon" src={playIcon} alt="" />
      </div>

      <div className="dbi-steam-news-item-info">
        <div className="dbi-steam-news-item-title-wrapper">
          <div className="dbi-steam-news-item-title">{data.title}</div>
          {isHovering && <img src={jumpHover} onClick={handleClick} />}
        </div>
        <div className="dbi-steam-news-item-sub-title" style={{ color: data.subTitleColor }}>
          {data.subTitle}
        </div>
        <div className="dbi-steam-news-item-sub-desc">{data.desc}</div>
      </div>
    </div>
  );
}

export default SteamNewsItem;
